// extracted by mini-css-extract-plugin
module.exports = {"container":"News_container__2-xAR","image":"News_image__29c8N"};